import { render, staticRenderFns } from "./companySettings.vue?vue&type=template&id=9dbf459e"
import script from "./companySettings.vue?vue&type=script&lang=js"
export * from "./companySettings.vue?vue&type=script&lang=js"
import style0 from "./companySettings.vue?vue&type=style&index=0&id=9dbf459e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports